// @flow

import Raven from 'raven-js';

export function logError(error: Error) {
  Raven.captureException(error);
}

// injected by webpack when building for production
declare var COMMITHASH: string;

export function initErrorLogging() {
  const env = process.env.NODE_ENV;
  if (env && env !== 'development') {
    Raven.config(process.env.REACT_APP_SENTRY_URL, {
      release: COMMITHASH,
      environment: env,
    }).install();
  }
}



// WEBPACK FOOTER //
// ./src/js/libs/Logger.js